import type { PlanComparer } from '@lib/sanity/sanity.types';
import { setPlanCodeCookie } from './setPlanCodeCookie';

// Trials are always offered on the MONTHLY plan, regardless of the billing
// frequency shown on the card (e.g. a Team yearly card starts a team-monthly
// trial). These recurly codes map to the in-app plans: Pro -> automate,
// Ultra -> ultra, Team -> team. The keys are the plan values an editor picks
// for a comparison-table column (planComparer.planCode in website-studio).
export const TRIAL_PLAN_CODES = {
  pro: 'automate-monthly',
  ultra: 'ultra-monthly',
  team: 'team-monthly',
} as const satisfies Record<NonNullable<PlanComparer['planCode']>, string>;

// Persist the chosen plan so the app can enroll its monthly trial after signup.
// setPlanCodeCookie writes to the shared parent domain (.thebrief.ai) with a
// 30-minute expiry; the app reads this `planCode` cookie during onboarding.
export function rememberSelectedTrialPlan(trialPlanCode?: string): void {
  if (trialPlanCode) {
    setPlanCodeCookie('planCode', trialPlanCode, 30, '/');
  }
}
